import apiFactory from '@scoir/api'

export const unauthFallBackUrlFn = () => '/signin'
export const jsonOptions = { headers: { 'Content-Type': 'application/json' } }
export default apiFactory(unauthFallBackUrlFn)
